<template>
    <div class="banner py-15 fr-ac-jc">
        <div class="bannerBox fr-ac">
            <div class="newImg">
                <p class="newProvince">{{ province }}</p>
                <img :src="IMG" class="WH-100" />
            </div>
            <div style="flex: 1">
                <img v-if="banner.banner.img" :src="banner.banner.img" class="WH-100" @click="pathOutClick({
                    ...banner.banner,
                    province
                })"/>
            </div>
        </div>
        <div v-if="couplet && banner.couplet && banner.couplet.left && banner.couplet.right">
            <img :src="banner.couplet.left.img" class="leftImg"  @click="pathOutClick({
                    ...banner.couplet.left,
                    province                
                })"/>
            <img :src="banner.couplet.right.img" class="rightImg"  @click="pathOutClick({
                    ...banner.couplet.right,
                    province                
                })"/>
        </div>
        <div v-if="suspension" class="suspension py-20 px-5">
            <el-popover
                placement="left"
                v-for="item in XCXLIST"
                :key="item.id"
                trigger="hover"
            >
                <div class="fc-ac-jc">
                    <img :src="`https://file.gkzzd.cn${item.QR_code}`" alt="" style="width: 150px;height: 150px;"/>
                    <div class="mt-5">{{ item.content }}</div>
                </div>
                <div slot="reference" class="fc-ac-jc py-10">
                    <img
                        :src="`https://file.gkzzd.cn${item.icon}`"
                        alt=""
                        style="width: 25px; height: 25px"
                    />
                    <div class="fs-14 mt-5">{{ item.title }}</div>
                </div>
            </el-popover>
        </div>
    </div>
</template>
<script>
import { getAdsClick } from '@/utils/api';

export default {
    name: "BannerView",
    props: {
        province: {
            type: String,
            default: "",
        },
        couplet: {
            type: Boolean,
            default: true,
        },
        suspension: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        banner() {
            const ad = this.$store.state.page_one.list_ad;
            // SSR 阶段 list_ad 初始是空对象,访问 .banner 会崩,降级为空对象
            // 数据回来后是 {banner:{img:...}, couplet:{left:{img:...}, right:{img:...}}}
            return (ad && ad.banner) ? ad : { banner: {}, couplet: {} };
        },
    },
    data() {
        return {
            IMG: `${process.env.VUE_APP_IMG_URL}/www/gkzzd/uploads/20241106/534ffce2e01f418683ac36ee0b402bd1.png`,
            XCXLIST: [
                {
                    id: 1,
                    title: "小程序",
                    content: "微信扫码访问小程序",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/f9d70655daf7b5843d967b9c2c7f1d9b.png",
                    icon: "/www/gkzzd/uploads/20250321/941fe8c7d744c52c3bb84534b6612a04.png",
                },
                {
                    id: 2,
                    title: "APP",
                    content: "微信扫码下载APP",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/e60af1b7f382fc29f4d24a2eb78f5352.png",
                    icon: "/www/gkzzd/uploads/20250321/f942bcd20c5c075157320dde1d2673ca.png",
                },
                {
                    id: 3,
                    title: "公众号",
                    content: "微信扫码关注公众号",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/3fa8db5e1e457528dad09cddad08710c.jpg",
                    icon: "/www/gkzzd/uploads/20250321/8736597b3c11252732b75da807b23095.png",
                },
            ],
        };
    },
    watch: {},
    methods: {
        async pathOutClick(val) {
            if (!val || !val.link) return;
            window.open(val.link, '_blank');
            const res = await getAdsClick({
                sf: val.province,
                ads_id: val.ads_id,
            })
        },
    },
    mounted() {
    },
    created() {},
};
</script>
<style lang="scss" scoped>
.banner {
    height: 170px;
    background-color: #3c78ff;
    .bannerBox {
        width: 1200px;
        height: 100%;
        .newImg {
            width: calc(100% / 4);
            position: relative;
            .newProvince {
                position: absolute;
                top: 50%;
                left: 13%;
                transform: translate(-50%, -50%);
                background: #d60707;
                writing-mode: vertical-rl; /* 竖排，从右到左 */
                font-size: 20px;
                padding: 5px 2px;
                font-weight: bold;
                color: #fff;
            }
        }
    }
    .leftImg {
        position: fixed;
        top: 240px;
        left: 30px;
        z-index: 999;
    }
    .rightImg {
        position: fixed;
        top: 240px;
        right: 30px;
        z-index: 999;
    }
    .suspension {
        position: fixed;
        bottom: 1%;
        right: 1px;
        transform: translate(-100%, -15%);
        background: #fff;
        border-radius: 25px;
        z-index: 999;
    }
}
</style>